
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexI8efbx71nHPzAx3gVqMerYJI2_UyWaKLKoZz8Nu8s6YMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93BvrZ8TKxqz5ia7GT2v8XE1BPy88cojHYvFQXF4oajmQMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/[...slug].vue?macro=true";
import { default as vergelijkjFA7tP9VquYq9_IKNDv_050az96eNdVulDUnAWC940UMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/vergelijk.vue?macro=true";
import { default as indexaOZs6wY1Hi_137WhYhCmnFiVAmfYO9HG49rDEXi9eVMMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/nieuws/index.vue?macro=true";
import { default as indexBZhLDu8X7aysa8q60mNyQynoYL5QhLlmDb4CZyG6tVQMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaar/index.vue?macro=true";
import { default as indexXgvebBLt92nP579g72kFgFO4c8QCJuHp_j9ERpXyCsUMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/index.vue?macro=true";
import { default as vergelijk_45aankoopQTzrL5wmEgMusYHkrbrStO81jykOBQU6D8OdtF9lovsMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/vergelijk-aankoop.vue?macro=true";
import { default as vergelijk_45taxatiewjv0s5vZA3NjjTb_hfw_MgslyleGNsag26dGQwpKQSQMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/vergelijk-taxatie.vue?macro=true";
import { default as vergelijk_45verkoopLIK0Y_HlgOhpVZJwHPxXbZQh5GYp27lI4Ae4kc7rHXQMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/vergelijk-verkoop.vue?macro=true";
import { default as feedback_451P94y5XzsjkLN2HDOfbzuVgBd2sbqiHyF40sFxOVLv9gMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/(forms)/feedback-1.vue?macro=true";
import { default as _91_46_46_46nieuwsslug_93r9pRMDhMVE6QtTwTTE7KLoQZtrspJj0ZBAMnYdC6fRYMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/nieuws/[...nieuwsslug].vue?macro=true";
import { default as accepteren_45aanvraag_a41al4rzZa2p1geA5dw5iUVEiHA66qDsKTnkQd5__0Meta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/(forms)/accepteren-aanvraag.vue?macro=true";
import { default as indexWctvovns5kKYCEkDl4PVajVgPJLmcfIEPukrTk6RMN4Meta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaar/[broker_slug]/index.vue?macro=true";
import { default as indexXdiYyb0JMlsIObe5zvE28eVgutqbNm5z2RiXZQBMs1cMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/[province_slug]/index.vue?macro=true";
import { default as indexw_xeoicsj85MzU6GDBmLbhIIVcvDvpRScgLX2ZMHDYwMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/[province_slug]/[location_slug]/index.vue?macro=true";
import { default as indexEPLkJbvukP9zc5lFpqmyLyRoJSStg0EsTmwNIv9PsdsMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/[province_slug]/[location_slug]/wijk/index.vue?macro=true";
import { default as indexxJ_9__vz_jf6SPdK7vRx_RYuV75mEDORWsUFaZ8a0_gMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/[province_slug]/[location_slug]/buurt/index.vue?macro=true";
import { default as indexj6N54VXk_jxxcP0FUrSVasPjWc6oOCJ71sfVgkQBDBAMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/[province_slug]/[location_slug]/wijk/[wijk_slug]/index.vue?macro=true";
import { default as indexxaTA0S2SOap2q7RDsIEg8pST7TVOEllHdEtob4_yv_MMeta } from "/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/[province_slug]/[location_slug]/buurt/[buurt_slug]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/[...slug].vue")
  },
  {
    name: "vergelijk",
    path: "/vergelijk",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/vergelijk.vue")
  },
  {
    name: "nieuws",
    path: "/nieuws",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/nieuws/index.vue")
  },
  {
    name: "makelaar",
    path: "/makelaar",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaar/index.vue")
  },
  {
    name: "makelaars",
    path: "/makelaars",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/index.vue")
  },
  {
    name: "vergelijk-aankoop",
    path: "/vergelijk-aankoop",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/vergelijk-aankoop.vue")
  },
  {
    name: "vergelijk-taxatie",
    path: "/vergelijk-taxatie",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/vergelijk-taxatie.vue")
  },
  {
    name: "vergelijk-verkoop",
    path: "/vergelijk-verkoop",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/vergelijk-verkoop.vue")
  },
  {
    name: "feedback-1",
    path: "/feedback-1",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/(forms)/feedback-1.vue")
  },
  {
    name: "nieuws-nieuwsslug",
    path: "/nieuws/:nieuwsslug(.*)*",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/nieuws/[...nieuwsslug].vue")
  },
  {
    name: "accepteren-aanvraag",
    path: "/accepteren-aanvraag",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/(forms)/accepteren-aanvraag.vue")
  },
  {
    name: "makelaar-broker_slug",
    path: "/makelaar/:broker_slug()",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaar/[broker_slug]/index.vue")
  },
  {
    name: "makelaars-province_slug",
    path: "/makelaars/:province_slug()",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/[province_slug]/index.vue")
  },
  {
    name: "makelaars-province_slug-location_slug",
    path: "/makelaars/:province_slug()/:location_slug()",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/[province_slug]/[location_slug]/index.vue")
  },
  {
    name: "makelaars-province_slug-location_slug-wijk",
    path: "/makelaars/:province_slug()/:location_slug()/wijk",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/[province_slug]/[location_slug]/wijk/index.vue")
  },
  {
    name: "makelaars-province_slug-location_slug-buurt",
    path: "/makelaars/:province_slug()/:location_slug()/buurt",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/[province_slug]/[location_slug]/buurt/index.vue")
  },
  {
    name: "makelaars-province_slug-location_slug-wijk-wijk_slug",
    path: "/makelaars/:province_slug()/:location_slug()/wijk/:wijk_slug()",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/[province_slug]/[location_slug]/wijk/[wijk_slug]/index.vue")
  },
  {
    name: "makelaars-province_slug-location_slug-buurt-buurt_slug",
    path: "/makelaars/:province_slug()/:location_slug()/buurt/:buurt_slug()",
    component: () => import("/Users/bartligthart/Documents/Vue/juistemakelaar/app/pages/makelaars/[province_slug]/[location_slug]/buurt/[buurt_slug]/index.vue")
  }
]